module.exports = __webpack_public_path__ + "media/images/rubicon_logo-e30dd36d00a451d2408b8c24371f6f19.png";